import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import "./UserModal.css";
import { MdOutlineEmail } from "react-icons/md";
import { LuUserRound, LuLock, LuEye } from "react-icons/lu";
import { HiOutlinePhone } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import UserImg from "../../assets/userimg.avif";
import api from "../../api";
import Swal from "sweetalert2";
import { color } from "framer-motion";
import { UserContext } from "../../context/UserContext";
Modal.setAppElement("#root");

const UserModal = ({ isOpen, onClose }) => {
  const { setUser } = useContext(UserContext);
  const [isLogin, setIsLogin] = useState(true);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phonenumber: "",
    confirmPassword: "",
    rememberMe: false,
    acceptTerms: false,
    nameChecked: false,
    emailChecked: false,
    passwordChecked: false,
    confirmPasswordChecked: false,
  });
  const [selectedCountry, setSelectedCountry] = useState("LB");

  const [countries, setCountries] = useState([]);

  useEffect(() => { }, [isLogin]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Pre-fill remembered email
  useEffect(() => {
    const rememberedEmail = localStorage.getItem("remembered_email") || "";

    if (rememberedEmail) {
      setFormData((prev) => ({
        ...prev,
        email: rememberedEmail,
        rememberMe: true,
      }));
    }
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setCheckingAuth(true);
      return;
    }

    const checkLoggedInUser = async () => {
      try {
        const res = await api.get("auth/me", {
          withCredentials: true,
        });

        // Local modal state
        setLoggedInUser(res.data);

        // Global UserContext
        setUser(res.data);

      } catch (err) {
        setLoggedInUser(null);
        setUser(null);
      } finally {
        setCheckingAuth(false);
      }
    };

    checkLoggedInUser();
  }, [isOpen, setUser]);

  // const handleCheckboxChange = (checkboxName) => {
  //   setFormData({
  //     ...formData,
  //     [checkboxName]: !formData[checkboxName]
  //   });
  // };
  useEffect(() => {
    const fetchCountries = async () => {
      const res = await api.get("countries/show-countries");
      setCountries(res.data);
    };
    fetchCountries();
  }, []);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const handleLogin = async (e) => {
    e.preventDefault();

    // Prevent double click
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);

      // 1. Login
      const res = await api.post("auth/login", {
        email: formData.email,
        password: formData.password,
        rememberMe: formData.rememberMe,
      });

      // 2. Save token
      localStorage.setItem(
        "auth_token",
        res.data.token
      );

      // 3. Get authenticated user
      const userResponse = await api.get(
        "auth/me"
      );

      setUser(userResponse.data);

      setLoggedInUser(
        res.data.user || userResponse.data
      );

      if (formData.rememberMe) {
        localStorage.setItem(
          "remembered_email",
          formData.email
        );
      } else {
        localStorage.removeItem(
          "remembered_email"
        );
      }

      setIsLogin(true);

      setFormData((prev) => ({
        ...prev,
        email: "",
        password: "",
        rememberMe: false,
      }));

      // Request finished successfully
      setIsSubmitting(false);

      onClose();

      await Swal.fire({
        title: "Login Successful",
        text:
          res.data.message ||
          "Welcome back!",
        icon: "success",
        confirmButtonText: "Continue",
        confirmButtonColor: "#993400",
      });
    } catch (err) {
      setIsSubmitting(false);

      if (err.response) {
        await Swal.fire({
          title: "Login Failed",
          text:
            err.response.data.message ||
            "Unable to login.",
          icon: "error",
          confirmButtonColor: "#993400",
          customClass: {
            container: "login-swal-on-top",
          },
        });
      } else {
        await Swal.fire({
          title: "Error",
          text:
            "Login failed. Try again later.",
          icon: "error",
          confirmButtonColor: "#993400",
          customClass: {
            container: "login-swal-on-top",
          },
        });
      }

      console.error(err);
    }
  };


  const handleForgotPassword = async () => {
    const emailResult = await Swal.fire({
      title: "Forgot Password",
      text:
        "Enter the email address associated with your account.",

      input: "email",

      inputValue: formData.email || "",

      inputPlaceholder:
        "Enter your email address",

      showCancelButton: true,

      confirmButtonText: "Send Code",

      confirmButtonColor: "#993400",

      customClass: {
        container: "login-swal-on-top",
      },

      inputValidator: (value) => {
        if (!value) {
          return "Please enter your email";
        }
      },
    });

    if (!emailResult.isConfirmed) {
      return;
    }

    const email = emailResult.value
      .trim()
      .toLowerCase();

    try {
      await api.post(
        "auth/forgot-password",
        {
          email,
        }
      );
    } catch (err) {
      await Swal.fire({
        title: "Unable to Send Code",

        text:
          err.response?.data?.message ||
          "Please try again.",

        icon: "error",

        confirmButtonColor: "#993400",

        customClass: {
          container: "login-swal-on-top",
        },
      });

      return;
    }

    const resetResult = await Swal.fire({
      title: "Reset Password",

      text:
        `A verification code was sent to ${email}. ` +
        "The code expires in 3 minutes.",

      html: `
      <input
        id="reset-otp"
        class="swal2-input"
        type="text"
        inputmode="numeric"
        maxlength="6"
        placeholder="6-digit verification code"
        autocomplete="one-time-code"
      />

      <input
        id="reset-password"
        class="swal2-input"
        type="password"
        placeholder="New password"
        autocomplete="new-password"
      />

      <input
        id="reset-confirm-password"
        class="swal2-input"
        type="password"
        placeholder="Confirm new password"
        autocomplete="new-password"
      />
    `,

      showCancelButton: true,

      confirmButtonText: "Reset Password",

      confirmButtonColor: "#993400",

      customClass: {
        container: "login-swal-on-top",
      },

      focusConfirm: false,

      preConfirm: async () => {
        const otp = document
          .getElementById("reset-otp")
          ?.value
          .trim();

        const newPassword = document
          .getElementById("reset-password")
          ?.value;

        const confirmPassword = document
          .getElementById(
            "reset-confirm-password"
          )
          ?.value;

        if (!/^\d{6}$/.test(otp || "")) {
          Swal.showValidationMessage(
            "Please enter the 6-digit code."
          );

          return false;
        }

        if (!newPassword || newPassword.length < 8) {
          Swal.showValidationMessage(
            "Password must contain at least 8 characters."
          );

          return false;
        }

        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage(
            "Passwords do not match."
          );

          return false;
        }

        try {
          const response = await api.post(
            "auth/reset-password",
            {
              email,
              otp,
              newPassword,
            }
          );

          return response.data;
        } catch (err) {
          const status = err.response?.status;

          if (status === 410) {
            Swal.showValidationMessage(
              "This code has expired. Close this window and click Forgot password again."
            );
          } else if (status === 429) {
            Swal.showValidationMessage(
              "Too many incorrect attempts. Please request a new code."
            );
          } else {
            Swal.showValidationMessage(
              err.response?.data?.message ||
              "Unable to reset password."
            );
          }

          return false;
        }
      },
    });

    if (
      resetResult.isConfirmed &&
      resetResult.value
    ) {
      setFormData((prev) => ({
        ...prev,
        password: "",
      }));

      await Swal.fire({
        title: "Password Reset",

        text:
          "Your password has been changed successfully. You can now log in.",

        icon: "success",

        confirmButtonText: "Login",

        confirmButtonColor: "#993400",

        customClass: {
          container: "login-swal-on-top",
        },
      });
    }
  };
  // Logout///////////////////
  const handleLogout = async () => {
    try {
      const rememberedEmail = localStorage.getItem("remembered_email") || "";


      localStorage.removeItem("auth_token");
      await api.post(
        "auth/logout",
        {},
        {
          withCredentials: true,
        },
      );

      setLoggedInUser(null);
      setUser(null);
      setIsLogin(true);

      setFormData((prev) => ({
        ...prev,
        email: rememberedEmail,
        password: "",
        rememberMe: !!rememberedEmail,
      }));


      Swal.fire({
        title: "Logged Out",
        text: "You have been logged out successfully.",
        icon: "success",
        confirmButtonColor: "#993400",
      });
    } catch (err) {
      console.error("Logout error:", err);

      Swal.fire({
        title: "Error",
        text: "Unable to log out. Please try again.",
        icon: "error",
      });
    }
  };
  // //////////////////////////////////////////

  const handleRegister = async (e) => {
    e.preventDefault();

    // Prevent double click / double request
    if (isSubmitting) return;

    if (formData.password !== formData.confirmPassword) {
      Swal.fire({
        title: "Passwords do not match",
        text: "Please make sure both passwords are identical.",
        icon: "error",
        confirmButtonColor: "#993400",
        customClass: {
          container: "login-swal-on-top",
        },
      });

      return;
    }

    const selectedCountryData = countries.find(
      (country) => country.code === selectedCountry
    );

    const phoneCode =
      selectedCountryData?.phone_code || "";

    const fullPhone =
      phoneCode + formData.phonenumber;

    const data = {
      Action: "register",
      name: formData.name,
      email: formData.email,
      phonenumber: fullPhone,
      country: selectedCountry,
      password: formData.password,
    };

    try {
      // Start loader
      setIsSubmitting(true);

      const res = await api.post("user", data);

      // API returned successfully -> stop loader
      setIsSubmitting(false);

      const registeredEmail = formData.email;

      // Show SUCCESS message
      await Swal.fire({
        title: "Registration Successful",
        text:
          res.data?.message ||
          "Your account has been created successfully. You can now log in.",
        icon: "success",
        confirmButtonText: "Login",
        confirmButtonColor: "#993400",
        customClass: {
          container: "login-swal-on-top",
        },
      });

      // Open login directly after success message
      setIsLogin(true);

      // Keep registered email ready for login
      setFormData({
        name: "",
        email: registeredEmail,
        password: "",
        phonenumber: "",
        confirmPassword: "",
        rememberMe: false,
        acceptTerms: false,
        nameChecked: false,
        emailChecked: false,
        passwordChecked: false,
        confirmPasswordChecked: false,
      });

      setShowPassword(false);
      setShowConfirmPassword(false);
    } catch (err) {
      // Stop loader
      setIsSubmitting(false);

      if (err.response) {
        await Swal.fire({
          title: "Registration Failed",
          text:
            err.response.data.message ||
            "Unable to create your account.",
          icon: "error",
          confirmButtonColor: "#993400",
          customClass: {
            container: "login-swal-on-top",
          },
        });
      } else {
        await Swal.fire({
          title: "Registration Failed",
          text: "Registration failed. Try again later.",
          icon: "error",
          confirmButtonColor: "#993400",
          customClass: {
            container: "login-swal-on-top",
          },
        });
      }

      console.error(err);
    }
  };
  if (isOpen && checkingAuth) {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="auth-overlay"
        className="auth-box"
      >
        <div className="auth-header">
          <h2 className="auth-title">Loading...</h2>

          <button
            className="auth-close-btn"
            onClick={onClose}
            type="button"
            aria-label="Close modal"
          >
            <IoClose size={24} />
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="auth-overlay"
      className="auth-box"
    >
      <div className="auth-header">
        <h2 className="auth-title">
          {loggedInUser ? "My Account" : isLogin ? "Login" : "Registration"}
        </h2>
        <button
          className="auth-close-btn"
          onClick={onClose}
          type="button"
          aria-label="Close modal"
        >
          <IoClose size={24} />
        </button>
      </div>
      <div className="user-img">
        <img src={UserImg} alt="" />
      </div>
      {loggedInUser ? (
        <div className="logged-user">
          <h3>Welcome, {loggedInUser.name}</h3>

          <p>{loggedInUser.email}</p>

          <button type="button" className="primary-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      ) : (
        <>
          <form className="auth-form" onSubmit={isLogin ? handleLogin : handleRegister}>
            {!isLogin && (
              <div className="input-row">
                {/* <div 
              className={`checkbox-icon ${formData.nameChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('nameChecked')}
            >
              {formData.nameChecked && <FaCheck />}
            </div> */}
                <div className="input-group-user">
                  <LuUserRound />
                  <input
                    type="text"
                    placeholder="Enter your name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            )}

            <div className="input-row">
              {/* {!isLogin && (
            <div 
              className={`checkbox-icon ${formData.emailChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('emailChecked')}
            >
              {formData.emailChecked && <FaCheck />}
            </div>
          )} */}
              <div className="input-group-user">
                <MdOutlineEmail />
                <input
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {!isLogin && (
              <div className="input-row">
                <div className="input-group-user">
                  <HiOutlinePhone />
                  <select
                    value={selectedCountry}
                    onChange={(e) =>
                      setSelectedCountry(e.target.value)
                    }
                    style={{
                      width: "120px",
                      marginRight: "10px",
                    }}
                  >
                    {countries.map((country) => (
                      <option
                        key={country.id}
                        value={country.code}
                      >
                        {country.name} ({country.phone_code})
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    placeholder="Enter your phone number"
                    name="phonenumber"
                    value={formData.phonenumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
            )}

            <div className="input-row">
              {/* {!isLogin && (
            <div 
              className={`checkbox-icon ${formData.passwordChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('passwordChecked')}
            >
              {formData.passwordChecked && <FaCheck />}
            </div>
          )} */}
              <div className="input-group-user">
                <LuLock />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder={
                    isLogin ? "Create a password" : "Create a password"
                  }
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                <LuEye className="eye" onClick={togglePasswordVisibility} />
              </div>
            </div>

            {!isLogin && (
              <div className="input-row">
                {/* <div 
              className={`checkbox-icon ${formData.confirmPasswordChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('confirmPasswordChecked')}
            >
              {formData.confirmPasswordChecked && <FaCheck />}
            </div> */}
                <div className="input-group-user">
                  <LuLock />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm a password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                  />
                  <LuEye
                    className="eye"
                    onClick={toggleConfirmPasswordVisibility}
                  />
                </div>
              </div>
            )}

            {isLogin ? (
              <div className="row">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    name="rememberMe"
                    checked={formData.rememberMe}
                    onChange={handleInputChange}
                  />
                  Remember me
                </label>
                <button
                  type="button"
                  className="link forgot-password-btn"
                  onClick={handleForgotPassword}
                >
                  Forgot password?
                </button>
              </div>
            ) : (
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="acceptTerms"
                  checked={formData.acceptTerms}
                  onChange={handleInputChange}
                />
                I accept all terms & conditions
                <Link
                  style={{ color: "#9a3300" }}
                  to="/TermsConditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </Link>
              </label>
            )}

            <button
              type="submit"
              className="primary-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="auth-btn-loading">
                  <span className="auth-btn-spinner"></span>

                  {isLogin
                    ? "Logging in..."
                    : "Registering..."}
                </span>
              ) : (
                isLogin
                  ? "Login Now"
                  : "Register Now"
              )}
            </button>
          </form>
          <p className="switch-text">
            {isLogin ? (
              <>
                Don't have an account?
                <span onClick={() => setIsLogin(false)}> Sign-up now</span>
              </>
            ) : (
              <>
                Already have an account?
                <span onClick={() => setIsLogin(true)}> Login now</span>
              </>
            )}
          </p>
        </>
      )}
    </Modal>
  );
};

export default UserModal;
